"use client";

import Avatar from "boring-avatars";

const CLAWY_PALETTE = ["#F5B731", "#2563EB", "#E8712B", "#2D9A5F", "#F09CC0"];

type AgentAvatarProps = {
	readonly name: string;
	readonly size: number;
	readonly className?: string;
};

export function AgentAvatar({ name, size, className }: AgentAvatarProps) {
	return (
		<div className={className} style={{ width: size, height: size }}>
			<Avatar size={size} name={name} variant="beam" colors={CLAWY_PALETTE} />
		</div>
	);
}
